import { render, staticRenderFns } from "./ProTransaction.vue?vue&type=template&id=2a75dada"
import script from "./ProTransaction.vue?vue&type=script&lang=js"
export * from "./ProTransaction.vue?vue&type=script&lang=js"
import style0 from "./ProTransaction.vue?vue&type=style&index=0&id=2a75dada&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports